export default {"src":"/_next/static/media/profile-icon.45eaf906.svg","height":20,"width":20};